import noJobsImage from "../../assets/empty-state.png";
import "./EmptyState.scss";

export default function EmptyState({ message, subMessage }) {
    return (
        <section 
            className="empty-state empty-state--bg"
            style={{
                backgroundImage: `url(${noJobsImage})`,
            }}
        >
            <div className="empty-state__overlay">
                <h2 className="empty-state__title">{message}</h2>
                {subMessage && (
                    <p className="empty-state__subtitle">{subMessage}</p>
                )}
            </div>
        </section>
    );
}